/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */

import { useEffect, useRef, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import CreateInviteForm from '../../../../../components/invite/createForm';
import SelectLocationsComponent from '../../../../../components/invite/selectLocationsTable';
import { getUserDetails } from '../../../../../redux/slices/user/userDetails';
import { useNavigate, useParams } from 'react-router-dom';
import { getInviteDetails } from '../../../../../redux/slices/accounts/invites/invites';
import { T, useTranslate } from '@tolgee/react';
import { PATH_PAGE } from '../../../../../routes/paths';
import LoadingCard from '../../../../../components/invite/loadingCard';
import { ACCESS_TYPE_SELECTED } from '../../../../../config/roles';

const EditInvite: React.FC = () => {
  const { t } = useTranslate();
  const formComponentRef = useRef(null);
  const [selectedLocations, setSelectedLocations] = useState<any>(null);
  const [selectedClouds, setSelectedClouds] = useState<any>(null);
  const { uuid } = useParams();
  const {
    invite: { location_uuid_list, cloud_uuid_list, isLoading }
  } = useSelector((state: any) => state.invites);

  useEffect(() => {
    if (!isLoading) {
      setSelectedLocations(location_uuid_list);
      setSelectedClouds(cloud_uuid_list);
    }
  }, [isLoading, location_uuid_list, cloud_uuid_list]);

  const dispatch = useDispatch();
  const [cloudAccessType, setCloudAccessType] =
    useState<any>(ACCESS_TYPE_SELECTED);
  const [cockpitAccessType, setCockpitAccessType] =
    useState<any>(ACCESS_TYPE_SELECTED);
  useEffect(() => {
    dispatch(getUserDetails() as any);
    dispatch(getInviteDetails({ uuid }) as any);
  }, [dispatch]);
  const [cockpitRole, setCockpitRole] = useState<any>(null);
  const [cloudRole, setCloudRole] = useState<any>(null);
  const navigate = useNavigate();
  const {
    invite: { isLoading: isInviteLoading }
  } = useSelector((state: any) => state.invites);
  return (
    <Container>
      <div className="m-2" />
      <div className={'mb-2'}>
        <a
          onClick={() => {
            navigate(PATH_PAGE.team_management);
          }}
          className={'badge bg-secondary text-dark cursor-pointer'}
        >
          <T keyName={'back_button.back'}></T>
        </a>
      </div>
      <div className="m-2" />
      <div className="card p-4 d-flex justify-content-center align-items-center">
        <T keyName={'info_message.you_cannot_update_email_on_invite_edit'}></T>
      </div>
      <div className="m-2" />
      {isInviteLoading ? (
        <LoadingCard />
      ) : (
        <CreateInviteForm
          cloudAccessType={cloudAccessType}
          cockpitAccessType={cockpitAccessType}
          setCockpitRole={setCockpitRole}
          ref={formComponentRef}
          setCloudRole={setCloudRole}
          inviteUpdate={true}
          uuid={uuid}
          selectedLocations={selectedLocations}
          selectedClouds={selectedClouds}
        />
      )}

      <div className="m-2" />

      {!isLoading && (
        <SelectLocationsComponent
          setCloudAccessType={setCloudAccessType}
          setCockpitAccessType={setCockpitAccessType}
          cloudAccessType={cloudAccessType}
          cockpitAccessType={cockpitAccessType}
          cockpitRole={cockpitRole}
          cloudRole={cloudRole}
          selectedLocations={selectedLocations || []}
          setSelectedLocations={setSelectedLocations}
          selectedClouds={selectedClouds || []}
          setSelectedClouds={setSelectedClouds}
        />
      )}
      {isLoading === false && (
        <div className="card mt-2 p-4">
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => {
                navigate(PATH_PAGE.team_management);
              }}
              size="sm"
              variant="secondary"
            >
              {t('buttons.cancel')}
            </Button>
            <div className="m-2" />
            <Button
              onClick={() => {
                if (formComponentRef.current)
                  formComponentRef.current?.submitForm()();
              }}
              size="sm"
            >
              {t('invite.createForm.save')}
            </Button>
          </div>
        </div>
      )}
    </Container>
  );
};
export default EditInvite;
